export default __webpack_public_path__ + "static/media/slide2.df534cc5.jpg";